// Снэкбар «Нет интернета» над нижними вкладками (макет «Snackbar»: поля 8/24, жёлтая карточка r16 высотой 64, иконка 24, заголовок 15/20, подпись 12/16). Источник — onlineManager TanStack Query (события online/offline):
// пока сети нет, запросы стоят на паузе, а при её возвращении он сам перезапрашивает устаревшее.
// Экран с кэшем может заменить текст своим (Figma «Матч · сыгран · Нет интернета»: «Нет сети. Показан счёт от 14:32» + «Повторить»).
import { useEffect, useSyncExternalStore } from 'react';
import { onlineManager } from '@tanstack/react-query';
import infoIcon from '../assets/states/info.svg';
import { t } from '../i18n/i18n';
import styles from './OfflineBanner.module.css';

export interface OfflineNote { title: string; action?: { label: string; onPress: () => void } }

let note: OfflineNote | null = null;
const listeners = new Set<() => void>();
const subscribe = (cb: () => void) => { listeners.add(cb); return () => { listeners.delete(cb); }; };
const setNote = (next: OfflineNote | null) => { note = next; listeners.forEach((cb) => cb()); };

/** Пока экран открыт, плашка «нет сети» говорит его текстом; null — обычный текст. */
export function useOfflineNote(next: OfflineNote | null) {
  const title = next?.title;
  const label = next?.action?.label;
  const onPress = next?.action?.onPress;
  useEffect(() => {
    if (!title) return;
    setNote({ title, action: label && onPress ? { label, onPress } : undefined });
    return () => setNote(null);
  }, [title, label, onPress]);
}

export function OfflineBanner() {
  const online = useSyncExternalStore((cb) => onlineManager.subscribe(cb), () => onlineManager.isOnline());
  const custom = useSyncExternalStore(subscribe, () => note);
  if (online) return null;
  return (
    <div className={styles.wrap}>
      <div className={styles.banner} role="status">
        <img className={styles.icon} src={infoIcon} alt="" width={24} height={24} />
        <span className={styles.text}>
          <span className={styles.title}>{custom?.title ?? t('shell.offline.title')}</span>
          {custom?.action
            ? <button className={`${styles.sub} ${styles.action}`} onClick={custom.action.onPress}>{custom.action.label}</button>
            : !custom && <span className={styles.sub}>{t('shell.offline.text')}</span>}
        </span>
      </div>
    </div>
  );
}
